import {InsightsPageState} from './insightsPage.types';

const insightsPageInitialState: InsightsPageState = {
  measuredPeriod: {
    activeSince: '',
    timezone: '',
    timezoneOptions: [],
  },
  availableMetricsWithTotals: [],
  availableDimensions: [],
  dashboards: [],
  widgets: [],
  availableFilters: [],
};

export {insightsPageInitialState};
